import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

class ConfirmInputDialog extends React.Component {
  state = {
    disableOkButton: false,
  };

  constructor() {
    super();
    this.canSave = this.canSave.bind(this);
  }

  canSave() {
    const required = this.props.required || false;
    if (required) {
      const canSave =
        document.getElementById("note-message") &&
        document.getElementById("note-message").value &&
        document.getElementById("note-message").value !== "";
      this.setState({ disableOkButton: !canSave });
    }
  }

  render() {
    const title = this.props.title;
    const message = this.props.message;
    const buttons = this.props.buttons ? this.props.buttons : ["Cancel", "Ok"];

    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.props.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              style={{ whiteSpace: "pre-line" }}
            >
              {message}
            </DialogContentText>
            <textarea
              rows="5"
              id="note-message"
              style={{ width: "100%" }}
              onChange={() => {
                this.canSave();
              }}
            ></textarea>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.handleCancel} color="primary">
              {buttons[0]}
            </Button>
            <Button
              onClick={() => {
                this.props.handleOk(
                  document.getElementById("note-message").value
                );
              }}
              disabled={this.state.disableOkButton}
              color="primary"
            >
              {buttons[1]}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default ConfirmInputDialog;
